const LAZY_LOAD_VIEW = (path) => () =>
  import(
    /* webpackChunkName: "view-operations-materials-and-equipments-requests-[request]" */ `@/views/pei/materials-and-equipments-requests/${path}`
  );

export const MATERIALS_AND_EQUIPMENTS_REQUESTS_ROUTES = [
  {
    path: 'materials-and-equipments-requests',
    component: LAZY_LOAD_VIEW`Wrapper.vue`,
    children: [
      {
        path: '',
        name: 'materials-and-equipments-requests',
        component: LAZY_LOAD_VIEW`Main.vue`,
      },
      {
        path: 'manage/:id?',
        name: 'materials-and-equipments-requests-add',
        component: LAZY_LOAD_VIEW`manage/Main.vue`,
      },
    ],
  },
];
